/**
 * useSuggestionPosition — anchor a tip-tap suggestion popup to the cursor.
 *
 * The `Suggestion({...})` factory gives each render a `clientRect` callback
 * that returns the cursor's bounding rect. We translate that into inline
 * `position: fixed` styles so the popup floats next to the caret.
 *
 * Used by SlashMenu, MentionList, and PageLinkPicker.
 */

import { useLayoutEffect, useState } from 'react'

interface ClientRect {
  (): DOMRect | null
}

export function useSuggestionPosition(clientRect: ClientRect | null | undefined) {
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null)

  useLayoutEffect(() => {
    if (!clientRect) return
    const rect = clientRect()
    if (!rect) {
      setPos(null)
      return
    }
    setPos({ top: rect.bottom + 4, left: rect.left })
  }, [clientRect])

  if (!pos) return null
  return pos
}
